import { HttpClient } from '@angular/common/http';
import { ExtractModel } from '../models/extract.model';
import { Injectable } from '@angular/core';
import { AppService } from '../app.service';
import Auth from '../helpers/auth';

@Injectable()
export class ExtractService extends AppService<ExtractModel> {

  constructor(http: HttpClient) {
    super(http);
  }

  async getAll() {
    const result = await this.getAllAsync(`Responsible/${Auth.getToken()}/Extract`);
    return result;
  }

  async getAllByFilter(currentPage: number, daysOfResume: number, id?: string, tipo?) {
    let result;
    const count = 20;
    const interval = count * currentPage;
    const filters = `skip=${interval}&take=${count}&daysOfResume=${daysOfResume}`;
    if (tipo === 'rotativo') {
      result = await this.getAllAsync(`CartaoCashlessRotativo/Meus/${id}/Extrato?${filters}`);
    } else {
      result = await this.getAllAsync(`CartaoCashlessNominal/Meus/${id}/Extrato?${filters}`);
    }

    return result;
  }

  async getDetails(tag: string, id: string, tipo) {
    let result;
    if (tipo === 'rotativo') {
      result = await this.getAllAsync(`CartaoCashlessRotativo/Meus/${tag}/Extrato/${id}`);
    } else {
      result = await this.getAllAsync(`CartaoCashlessNominal/Meus/${tag}/Extrato/${id}`);
    }
    return result;
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/extract.service.ts